import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

var PIE_COLORS = ["#F26A4B", "#3B82F6", "#10b981"];

function formatVal(v) {
  if (v == null || v === 0) return "R$ 0";
  if (v >= 1000) return "R$ " + (v / 1000).toFixed(1) + "k";
  return "R$ " + v.toFixed(0);
}

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload) return null;
  var items = [];
  for (var i = 0; i < payload.length; i++) {
    var p = payload[i];
    items.push(
      <p key={i} style={{ color: p.color }}>{p.name}: {formatVal(p.value)}</p>
    );
  }
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-3 text-xs">
      <p className="font-semibold text-[#0A2F3D] mb-1">{label}</p>
      {items}
    </div>
  );
}

export function MonthlyBarChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="flex items-center justify-center h-60 text-gray-300 text-sm">Sem dados de comissões</div>;
  }
  return (
    <div style={{ width: "100%", height: 260 }}>
      <ResponsiveContainer>
        <BarChart data={data} barGap={2}>
          <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={false} tickLine={false} tickFormatter={formatVal} />
          <Tooltip content={ChartTooltip} />
          <Bar dataKey="pago" name="Pago" fill="#10b981" radius={[4, 4, 0, 0]} />
          <Bar dataKey="pendente" name="Pendente" fill="#f59e0b" radius={[4, 4, 0, 0]} />
          <Bar dataKey="travada" name="Travada" fill="#ef4444" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function ProductPieChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="flex items-center justify-center h-60 text-gray-300 text-sm">Sem dados</div>;
  }
  var cells = [];
  for (var i = 0; i < data.length; i++) {
    cells.push(<Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />);
  }
  return (
    <div style={{ width: "100%", height: 260 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={3}>
            {cells}
          </Pie>
          <Tooltip formatter={function(v) { return formatVal(v); }} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
